#!/usr/bin/env -S node --no-warnings --enable-source-maps
import { run } from '../bins.ts'
await run('exec')
